<textarea
  id="myTextarea"
  class="input-text scrollbar"
  id="style-1"
  (input)="autoResize($event)"
  [ngClass]="className"
  [formControl]="control"
  [ngStyle]="{'width': width, 'height': height}"
  #input_comp 
  (input)="_change(input_comp.value)"
  [value]="value"
></textarea>
